/**
 * Keyboard tables, extracted from rdev (github.com/rustdesk-org/rdev), which is
 * what the desktop client uses. Generated - do not hand-edit.
 *
 * The mapping the desktop client performs in Map mode is:
 *
 *   local key identity  ->  Key  ->  code in the PEER's platform
 *
 * A browser gives us `KeyboardEvent.code`, which is the same string rdev's
 * chrome table uses, so the browser path is:
 *
 *   event.code -> CODE_TO_KEY -> KEY_TO_{WIN_SCANCODE,LINUX,MACOS}
 *
 * Sending a Windows scancode to a Linux peer (or vice versa) produces the
 * wrong key, which is why this is selected from the peer's reported platform.
 */
export const CODE_TO_KEY = {
    '': 'Pause',
    AltLeft: 'Alt',
    AltRight: 'AltGr',
    ArrowDown: 'DownArrow',
    ArrowLeft: 'LeftArrow',
    ArrowRight: 'RightArrow',
    ArrowUp: 'UpArrow',
    AudioVolumeDown: 'VolumeDown',
    AudioVolumeMute: 'VolumeMute',
    AudioVolumeUp: 'VolumeUp',
    Backquote: 'BackQuote',
    Backslash: 'BackSlash',
    Backspace: 'Backspace',
    BracketLeft: 'LeftBracket',
    BracketRight: 'RightBracket',
    CapsLock: 'CapsLock',
    Comma: 'Comma',
    ContextMenu: 'Apps',
    ControlLeft: 'ControlLeft',
    ControlRight: 'ControlRight',
    Convert: 'Convert',
    Delete: 'Delete',
    Digit0: 'Num0',
    Digit1: 'Num1',
    Digit2: 'Num2',
    Digit3: 'Num3',
    Digit4: 'Num4',
    Digit5: 'Num5',
    Digit6: 'Num6',
    Digit7: 'Num7',
    Digit8: 'Num8',
    Digit9: 'Num9',
    End: 'End',
    Enter: 'Return',
    Equal: 'Equal',
    Escape: 'Escape',
    F1: 'F1',
    F10: 'F10',
    F11: 'F11',
    F12: 'F12',
    F13: 'F13',
    F14: 'F14',
    F15: 'F15',
    F16: 'F16',
    F17: 'F17',
    F18: 'F18',
    F19: 'F19',
    F2: 'F2',
    F20: 'F20',
    F21: 'F21',
    F22: 'F22',
    F23: 'F23',
    F24: 'F24',
    F3: 'F3',
    F4: 'F4',
    F5: 'F5',
    F6: 'F6',
    F7: 'F7',
    F8: 'F8',
    F9: 'F9',
    Home: 'Home',
    Insert: 'Insert',
    IntlBackslash: 'IntlBackslash',
    IntlRo: 'IntlRo',
    IntlYen: 'IntlYen',
    KanaMode: 'KanaMode',
    KeyA: 'KeyA',
    KeyB: 'KeyB',
    KeyC: 'KeyC',
    KeyD: 'KeyD',
    KeyE: 'KeyE',
    KeyF: 'KeyF',
    KeyG: 'KeyG',
    KeyH: 'KeyH',
    KeyI: 'KeyI',
    KeyJ: 'KeyJ',
    KeyK: 'KeyK',
    KeyL: 'KeyL',
    KeyM: 'KeyM',
    KeyN: 'KeyN',
    KeyO: 'KeyO',
    KeyP: 'KeyP',
    KeyQ: 'KeyQ',
    KeyR: 'KeyR',
    KeyS: 'KeyS',
    KeyT: 'KeyT',
    KeyU: 'KeyU',
    KeyV: 'KeyV',
    KeyW: 'KeyW',
    KeyX: 'KeyX',
    KeyY: 'KeyY',
    KeyZ: 'KeyZ',
    Lang1: 'Lang1',
    Lang2: 'Lang2',
    Lang3: 'Lang3',
    Lang4: 'Lang4',
    Lang5: 'Lang5',
    MetaLeft: 'MetaLeft',
    MetaRight: 'MetaRight',
    Minus: 'Minus',
    NonConvert: 'NonConvert',
    NumLock: 'NumLock',
    Numpad0: 'Kp0',
    Numpad1: 'Kp1',
    Numpad2: 'Kp2',
    Numpad3: 'Kp3',
    Numpad4: 'Kp4',
    Numpad5: 'Kp5',
    Numpad6: 'Kp6',
    Numpad7: 'Kp7',
    Numpad8: 'Kp8',
    Numpad9: 'Kp9',
    NumpadAdd: 'KpPlus',
    NumpadComma: 'KpComma',
    NumpadDecimal: 'KpDecimal',
    NumpadDivide: 'KpDivide',
    NumpadEnter: 'KpReturn',
    NumpadEqual: 'KpEqual',
    NumpadMultiply: 'KpMultiply',
    NumpadSubtract: 'KpMinus',
    PageDown: 'PageDown',
    PageUp: 'PageUp',
    Period: 'Dot',
    PrintScreen: 'PrintScreen',
    Quote: 'Quote',
    ScrollLock: 'ScrollLock',
    Semicolon: 'SemiColon',
    ShiftLeft: 'ShiftLeft',
    ShiftRight: 'ShiftRight',
    Slash: 'Slash',
    Space: 'Space',
    Tab: 'Tab',
};
export const KEY_TO_USB_HID = {
    Alt: 226,
    AltGr: 230,
    Apps: 101,
    BackQuote: 53,
    BackSlash: 49,
    Backspace: 42,
    Cancel: 155,
    CapsLock: 57,
    Clear: 156,
    Comma: 54,
    ControlLeft: 224,
    ControlRight: 228,
    Convert: 138,
    Delete: 76,
    Dot: 55,
    DownArrow: 81,
    End: 77,
    Equal: 46,
    Escape: 41,
    Execute: 116,
    F1: 58,
    F10: 67,
    F11: 68,
    F12: 69,
    F13: 104,
    F14: 105,
    F15: 106,
    F16: 107,
    F17: 108,
    F18: 109,
    F19: 110,
    F2: 59,
    F20: 111,
    F21: 112,
    F22: 113,
    F23: 114,
    F24: 115,
    F3: 60,
    F4: 61,
    F5: 62,
    F6: 63,
    F7: 64,
    F8: 65,
    F9: 66,
    Final: 0,
    Hangul: 144,
    Hanja: 145,
    Help: 117,
    Home: 74,
    Insert: 73,
    IntlBackslash: 100,
    IntlRo: 135,
    IntlYen: 137,
    Junja: 0,
    Kana: 136,
    KeyA: 4,
    KeyB: 5,
    KeyC: 6,
    KeyD: 7,
    KeyE: 8,
    KeyF: 9,
    KeyG: 10,
    KeyH: 11,
    KeyI: 12,
    KeyJ: 13,
    KeyK: 14,
    KeyL: 15,
    KeyM: 16,
    KeyN: 17,
    KeyO: 18,
    KeyP: 19,
    KeyQ: 20,
    KeyR: 21,
    KeyS: 22,
    KeyT: 23,
    KeyU: 24,
    KeyV: 25,
    KeyW: 26,
    KeyX: 27,
    KeyY: 28,
    KeyZ: 29,
    Kp0: 98,
    Kp1: 89,
    Kp2: 90,
    Kp3: 91,
    Kp4: 92,
    Kp5: 93,
    Kp6: 94,
    Kp7: 95,
    Kp8: 96,
    Kp9: 97,
    KpComma: 133,
    KpDecimal: 99,
    KpDivide: 84,
    KpEqual: 103,
    KpMinus: 86,
    KpMultiply: 85,
    KpPlus: 87,
    KpReturn: 88,
    Lang1: 144,
    Lang2: 145,
    Lang3: 146,
    Lang4: 147,
    Lang5: 148,
    LeftArrow: 80,
    LeftBracket: 47,
    MetaLeft: 227,
    MetaRight: 231,
    Minus: 45,
    NonConvert: 139,
    Num0: 39,
    Num1: 30,
    Num2: 31,
    Num3: 32,
    Num4: 33,
    Num5: 34,
    Num6: 35,
    Num7: 36,
    Num8: 37,
    Num9: 38,
    NumLock: 83,
    PageDown: 78,
    PageUp: 75,
    Pause: 72,
    Print: 0,
    PrintScreen: 70,
    Quote: 52,
    Return: 40,
    RightArrow: 79,
    RightBracket: 48,
    ScrollLock: 71,
    Select: 119,
    SemiColon: 51,
    Separator: 159,
    ShiftLeft: 225,
    ShiftRight: 229,
    Slash: 56,
    Sleep: 0,
    Space: 44,
    Tab: 43,
    UpArrow: 82,
    VolumeDown: 129,
    VolumeMute: 127,
    VolumeUp: 128,
};
export const KEY_TO_WIN_SCANCODE = {
    Alt: 56,
    AltGr: 57400,
    Apps: 57437,
    BackQuote: 41,
    BackSlash: 43,
    Backspace: 14,
    Cancel: 0,
    CapsLock: 58,
    Clear: 0,
    Comma: 51,
    ControlLeft: 29,
    ControlRight: 57373,
    Convert: 121,
    Delete: 57427,
    Dot: 52,
    DownArrow: 57424,
    End: 57423,
    Equal: 13,
    Escape: 1,
    Execute: 0,
    F1: 59,
    F10: 68,
    F11: 87,
    F12: 88,
    F13: 100,
    F14: 101,
    F15: 102,
    F16: 103,
    F17: 104,
    F18: 105,
    F19: 106,
    F2: 60,
    F20: 107,
    F21: 108,
    F22: 109,
    F23: 110,
    F24: 118,
    F3: 61,
    F4: 62,
    F5: 63,
    F6: 64,
    F7: 65,
    F8: 66,
    F9: 67,
    Final: 0,
    Hangul: 242,
    Hanja: 241,
    Help: 0,
    Home: 57415,
    Insert: 57426,
    IntlBackslash: 86,
    IntlRo: 115,
    IntlYen: 125,
    Junja: 0,
    Kana: 128,
    KanaMode: 112,
    KeyA: 30,
    KeyB: 48,
    KeyC: 46,
    KeyD: 32,
    KeyE: 18,
    KeyF: 33,
    KeyG: 34,
    KeyH: 35,
    KeyI: 23,
    KeyJ: 36,
    KeyK: 37,
    KeyL: 38,
    KeyM: 50,
    KeyN: 49,
    KeyO: 24,
    KeyP: 25,
    KeyQ: 16,
    KeyR: 19,
    KeyS: 31,
    KeyT: 20,
    KeyU: 22,
    KeyV: 47,
    KeyW: 17,
    KeyX: 45,
    KeyY: 21,
    KeyZ: 44,
    Kp0: 82,
    Kp1: 79,
    Kp2: 80,
    Kp3: 81,
    Kp4: 75,
    Kp5: 76,
    Kp6: 77,
    Kp7: 71,
    Kp8: 72,
    Kp9: 73,
    KpComma: 126,
    KpDecimal: 83,
    KpDivide: 57397,
    KpEqual: 89,
    KpMinus: 74,
    KpMultiply: 55,
    KpPlus: 78,
    KpReturn: 57372,
    Lang1: 242,
    Lang2: 241,
    Lang3: 120,
    Lang4: 119,
    Lang5: 118,
    LeftArrow: 57419,
    LeftBracket: 26,
    MetaLeft: 57435,
    MetaRight: 57436,
    Minus: 12,
    NonConvert: 123,
    Num0: 11,
    Num1: 2,
    Num2: 3,
    Num3: 4,
    Num4: 5,
    Num5: 6,
    Num6: 7,
    Num7: 8,
    Num8: 9,
    Num9: 10,
    NumLock: 69,
    PageDown: 57425,
    PageUp: 57417,
    Pause: 0,
    Print: 0,
    PrintScreen: 57399,
    Quote: 40,
    Return: 28,
    RightArrow: 57421,
    RightBracket: 27,
    ScrollLock: 70,
    Select: 0,
    SemiColon: 39,
    Separator: 0,
    ShiftLeft: 42,
    ShiftRight: 54,
    Slash: 53,
    Sleep: 0,
    Space: 57,
    Tab: 15,
    UpArrow: 57416,
    VolumeDown: 57390,
    VolumeMute: 57376,
    VolumeUp: 57392,
};
export const KEY_TO_LINUX = {
    Alt: 64,
    AltGr: 108,
    Apps: 135,
    BackQuote: 49,
    BackSlash: 51,
    Backspace: 22,
    CapsLock: 66,
    Comma: 59,
    ControlLeft: 37,
    ControlRight: 105,
    Convert: 100,
    Delete: 119,
    Dot: 60,
    DownArrow: 116,
    End: 115,
    Equal: 21,
    Escape: 9,
    F1: 67,
    F10: 76,
    F11: 95,
    F12: 96,
    F13: 191,
    F14: 192,
    F15: 193,
    F16: 194,
    F17: 195,
    F18: 196,
    F19: 197,
    F2: 68,
    F20: 198,
    F21: 199,
    F22: 200,
    F23: 201,
    F24: 202,
    F3: 69,
    F4: 70,
    F5: 71,
    F6: 72,
    F7: 73,
    F8: 74,
    F9: 75,
    Hangul: 130,
    Hanja: 131,
    Home: 110,
    Insert: 118,
    IntlBackslash: 94,
    IntlRo: 97,
    IntlYen: 132,
    KanaMode: 101,
    KeyA: 38,
    KeyB: 56,
    KeyC: 54,
    KeyD: 40,
    KeyE: 26,
    KeyF: 41,
    KeyG: 42,
    KeyH: 43,
    KeyI: 31,
    KeyJ: 44,
    KeyK: 45,
    KeyL: 46,
    KeyM: 58,
    KeyN: 57,
    KeyO: 32,
    KeyP: 33,
    KeyQ: 24,
    KeyR: 27,
    KeyS: 39,
    KeyT: 28,
    KeyU: 30,
    KeyV: 55,
    KeyW: 25,
    KeyX: 53,
    KeyY: 29,
    KeyZ: 52,
    Kp0: 90,
    Kp1: 87,
    Kp2: 88,
    Kp3: 89,
    Kp4: 83,
    Kp5: 84,
    Kp6: 85,
    Kp7: 79,
    Kp8: 80,
    Kp9: 81,
    KpComma: 129,
    KpDecimal: 91,
    KpDivide: 106,
    KpEqual: 125,
    KpMinus: 82,
    KpMultiply: 63,
    KpPlus: 86,
    KpReturn: 104,
    Lang1: 130,
    Lang2: 131,
    Lang3: 98,
    Lang4: 99,
    Lang5: 93,
    LeftArrow: 113,
    LeftBracket: 34,
    MetaLeft: 133,
    MetaRight: 134,
    Minus: 20,
    NonConvert: 102,
    Num0: 19,
    Num1: 10,
    Num2: 11,
    Num3: 12,
    Num4: 13,
    Num5: 14,
    Num6: 15,
    Num7: 16,
    Num8: 17,
    Num9: 18,
    NumLock: 77,
    PageDown: 117,
    PageUp: 112,
    Pause: 127,
    PrintScreen: 107,
    Quote: 48,
    Return: 36,
    RightArrow: 114,
    RightBracket: 35,
    ScrollLock: 78,
    SemiColon: 47,
    ShiftLeft: 50,
    ShiftRight: 62,
    Slash: 61,
    Space: 65,
    Tab: 23,
    UpArrow: 111,
    VolumeDown: 122,
    VolumeMute: 121,
    VolumeUp: 123,
};
export const KEY_TO_MACOS = {
    Alt: 58,
    AltGr: 61,
    Apps: 110,
    BackQuote: 50,
    BackSlash: 42,
    Backspace: 51,
    CapsLock: 57,
    Comma: 43,
    ControlLeft: 59,
    ControlRight: 62,
    Delete: 117,
    Dot: 47,
    DownArrow: 125,
    End: 119,
    Equal: 24,
    Escape: 53,
    F1: 122,
    F10: 109,
    F11: 103,
    F12: 111,
    F13: 105,
    F14: 107,
    F15: 113,
    F16: 106,
    F17: 64,
    F18: 79,
    F19: 80,
    F2: 120,
    F20: 90,
    F3: 99,
    F4: 118,
    F5: 96,
    F6: 97,
    F7: 98,
    F8: 100,
    F9: 101,
    Function: 63,
    Home: 115,
    Insert: 114,
    IntlBackslash: 10,
    IntlRo: 94,
    IntlYen: 93,
    KeyA: 0,
    KeyB: 11,
    KeyC: 8,
    KeyD: 2,
    KeyE: 14,
    KeyF: 3,
    KeyG: 5,
    KeyH: 4,
    KeyI: 34,
    KeyJ: 38,
    KeyK: 40,
    KeyL: 37,
    KeyM: 46,
    KeyN: 45,
    KeyO: 31,
    KeyP: 35,
    KeyQ: 12,
    KeyR: 15,
    KeyS: 1,
    KeyT: 17,
    KeyU: 32,
    KeyV: 9,
    KeyW: 13,
    KeyX: 7,
    KeyY: 16,
    KeyZ: 6,
    Kp0: 82,
    Kp1: 83,
    Kp2: 84,
    Kp3: 85,
    Kp4: 86,
    Kp5: 87,
    Kp6: 88,
    Kp7: 89,
    Kp8: 91,
    Kp9: 92,
    KpComma: 95,
    KpDecimal: 65,
    KpDivide: 75,
    KpEqual: 81,
    KpMinus: 78,
    KpMultiply: 67,
    KpPlus: 69,
    KpReturn: 76,
    Lang1: 104,
    Lang2: 102,
    LeftArrow: 123,
    LeftBracket: 33,
    MetaLeft: 55,
    MetaRight: 54,
    Minus: 27,
    Num0: 29,
    Num1: 18,
    Num2: 19,
    Num3: 20,
    Num4: 21,
    Num5: 23,
    Num6: 22,
    Num7: 26,
    Num8: 28,
    Num9: 25,
    NumLock: 71,
    PageDown: 121,
    PageUp: 116,
    Quote: 39,
    Return: 36,
    RightArrow: 124,
    RightBracket: 30,
    SemiColon: 41,
    ShiftLeft: 56,
    ShiftRight: 60,
    Slash: 44,
    Space: 49,
    Tab: 48,
    UpArrow: 126,
    VolumeDown: 73,
    VolumeMute: 74,
    VolumeUp: 72,
};
